<div [ngClass]="rowClass">
	<!-- <div class="row flex-row"> -->
	<label [for]="formElement.name" [ngClass]="labelClass">
		<!-- <label [for]="formElement.name" class="col-4 col-form-label"> -->
		{{formElement.label}}
		<span class="mandatoryColor" *ngIf="(label || formElement.label) && (required ||formElement.required || formElement.showAstrisk)">*</span>
	</label>
	<div [ngClass]="inputClass">
		<!-- <div class="col-8"> -->
		<div class="row flex-row input-padding">
			<label [ngStyle]="{'cursor': disabled ? 'not-allowed' : 'pointer'}" [ngClass]="checkBoxClass" *ngFor="let checkbox of formElement.checkboxes">
				<input [disabled]="isDisabled()" (blur)="makeDirty()" type="checkbox" (change)="onChange()" [(ngModel)]="value[checkbox.name]"
				/>{{checkbox.label}}
				<span></span>
			</label>
		</div>

		<ng-content></ng-content>
	</div>
</div>
